import styled from 'styled-components';

import { Badge } from '../../../../../shared/Badge/Badge';

const POST_STATUS = {
  draft: 'var(--orange-9)',
  scheduled: '#99CBFF',
  live: 'var(--green-9)',
};

export const BadgeList = ({ status }) => (
  <StyledBadge
    variant="rounded"
    style={{
      backgroundColor: POST_STATUS[status],
      color: 'white',
      border: 'none',
    }}
  >
    {status}
  </StyledBadge>
);

const StyledBadge = styled(Badge)`
  text-transform: uppercase;
  width: min-content;
  white-space: nowrap;
  justify-self: right;
`;
